import { ReportSection, ReportSectionItemContent } from '@/components';
import type { ProjectModel } from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type z from 'zod';

type Props = {
  project: z.infer<typeof ProjectModel>;
};

export const AlasanDanTujuanReview: FC<Props> = ({ project }) => {
  const { t } = useTranslation();
  return (
    <ReportSection
      title={t('project-Alasan-dan-Tujuan-Review')}
      items={[
        {
          indexText: '7.',
          subtitle: t('project-alasan-review'),
          item: (
            <ReportSectionItemContent
              value={project.indonesiaData?.alasanReview}
            />
          ),
        },
        {
          indexText: '8.',
          subtitle: t('project-tujuan-review'),
          item: (
            <ReportSectionItemContent
              value={project.indonesiaData?.tujuanReview}
            />
          ),
        },
      ]}
    />
  );
};
